
import React, { useEffect, useState } from 'react';
import ApiService from 'services';
import { Table, Row, Col, Form } from 'react-bootstrap';
import { slugify } from 'utils/misc';
import TCABreadCrumb from 'components/breadcrumb';
import { getTeamLink } from 'utils/links';

function getIndex(index) {
    return index + 1;
}
export default function AllPlayers() {

    const [data, setData] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                console.log("doing network call");
                const response = await ApiService.getPlayers();
                setData(response);
                //console.log(response);

            } catch (error) {
                // Handle error
            }
        };

        fetchData();
    }, []);
    const breadCrumbData = [
        {
            title: "All Players",

        }
    ];
    return (
        <div>
            <Row>
                <Col>
                    <TCABreadCrumb breadCrumbData={breadCrumbData} />
                    <h1>Players</h1>
                </Col>
            </Row>
            <Row>
                <Col>
                    <span className='fs-5'>Filters: </span>
                    <div>
                        <Form.Check
                            inline
                            label="Show Active Team Players"
                            name="group1"
                            type="check"
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Table responsive striped bordered hover>
                        <thead>
                            <tr>
                                <th>S.No.</th>
                                <th>Player Name</th>
                                <th>Team Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.sort(function (a, b) {
                                // return a negative number if a < b, 0 if a == b, or a positive number if a > b
                                let aName = a.name.trim() || "N/A";
                                let bName = b.name.trim() || "N/A";
                                return (aName == bName ? 0 : (aName < bName ? -1 : 1))
                            }).map((onePlayer, index) => {
                                let playerSlug = slugify(onePlayer.name);
                     
                                return <tr key={index}>
                                    <td>{getIndex(index)}.</td>
                                    <td> <a href={"/players/" + playerSlug + "-" + onePlayer.id}> {onePlayer.name}</a></td>
                                    <td>{getTeamLink(onePlayer.teamName, onePlayer.teamId)}</td>
                                </tr>
                            })}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </div>
    );
}